import { configurationInterface } from "./configurationTypes";
import { RouterState } from "connected-react-router";
import { AdminNoteParsed, CreditsLogParsed, PhoneInterface, ShoppingCart } from "../models";

export interface rootReducerInterface {
  global?: globalInterface;
  router?: RouterState;
  auth?: authInterface;
  ad?: adInterface;
  favorite?: favoriteInterface;
  store?: storeInterface;
  hidden?: hiddenInterface;
  promotion?: promotionInterface;
  credit?: creditInterface;
  cart?: cartInterface;
  chat?: chatInterface;
  systemMessage?: any;
  search?: searchInterface;
  adForm?: adFormInterface;
  makeModelInfo?: any;
  configuration?: configurationInterface;
  admin?: any;
  phone?: phonesInterface;
  // {
  // global: unknown;
  // user: unknown;
  // operator: unknown;
  // category: unknown;
  // ad: unknown;
  // report: unknown;
  // configuration: unknown;
  // agency: unknown;
  // cvhToken: unknown;
  // home: unknown;
  // };
}

// GLOBAL
export interface globalInterface {
  categories?: categoriesInterface[];
  currentModule?: string;
  currentCategory?: string;
  filteredCategories?: any[];
  modules?: modulesInterface[];
  routes?: routeInterface[];
  searchMode?: string;
  isAIFeedbackModalVisible?: boolean;
  isAIFeedbackFormFilled?: boolean;
  isContactModalVisible: boolean;
  pollPopup?: PollPopupI | null;
}

// A single checkbox in a follow-up poll.
export interface PollOptionI {
  value: string | number;
  label: string;
}

// The second step an answer button opens: pick one or more options and
// optionally leave a comment. An answer without a `followUp` just closes the
// popup, as before.
export interface PollFollowUpI {
  title: string;
  options: PollOptionI[];
  commentPlaceholder?: string;
  submitText?: string;
}

// One of the two answer buttons. `onClick` fires the moment the button is
// pressed, before the follow-up (if any) is shown.
export interface PollAnswerButtonI {
  text?: string;
  followUp?: PollFollowUpI;
  onClick?: (poll: PollPopupI) => void;
}

// What `onSubmit` receives once the follow-up is sent.
export interface PollAnswerI {
  pollId: string;
  isYes: boolean;
  options: (string | number)[];
  comment: string;
}

// Config a page passes when it dispatches `showPollPopup`.
// `onCancel` belongs to the X icon only; the answer buttons report through
// their own `onClick` and, once a follow-up is filled in, through `onSubmit`.
// Every handler receives the poll itself so one handler can serve several polls.
export interface PollPopupI {
  pollId: string;
  title: string;
  yesAnswer?: PollAnswerButtonI;
  noAnswer?: PollAnswerButtonI;
  onCancel?: (poll: PollPopupI) => void;
  onSubmit?: (answer: PollAnswerI, poll: PollPopupI) => void | Promise<void>;
}

export interface routeInterface {
  MetaTitle?: string;
  MetaDescription?: string;
  H1?: string;
  Component?: string;
  to?: string;
  searchQuery?: string;
}

// configuration/modules
export interface modulesInterface {
  count?: number;
  displayName?: string;
  iconId?: string;
  name?: string;
  // url slug (auto-moto, nekretnine, ...)
  route?: string;
  is18Old?: boolean;
}

// configuration/categories
export interface categoriesInterface {
  count?: number;
  displayName?: string;
  iconId?: string;
  is18Old?: boolean;
  moduleName?: string;
  moduleRoute?: string;
  name?: string;
  // url slug (osobni-automobili, ...)
  route?: string;
}

// AUTH
export interface authInterface {
  user?: UserI | Object | null;
  profileLoading?: boolean;
}

export interface UserI {
  receiveXMLSyncNotifications: boolean;
  additionalCellPhone?: string;
  avatar?: string;
  canUpdateUsername?: boolean;
  cellPhone?: string;
  cityId?: string;
  countryId?: string;
  countyId?: string;
  dateOfBirth?: string;
  description?: string;
  email?: string;
  firstName?: string;
  houseNumber?: string;
  identityNumber?: string;
  isVerified?: boolean;
  isBlocked?: boolean;
  hasInvalidUsername?: boolean;
  hasVerifiedPhoneNumber?: boolean;
  phoneNumberVerificationPending?: boolean;
  lastName?: string;
  legalEntity?: boolean;
  legalEntityIdentifier?: string;
  phoneNumber?: string;
  role?: string;
  settlementId?: string;
  street?: string;
  userId?: string;
  username?: string;
  zipCode?: string;
  storeCreditBalance?: number;
  isUsingVATInvoice?: boolean,
  vatInvoiceCountryId?: string,
  vatInvoiceCityId?: string,
  vatInvoiceCountyId?: string,
  vatInvoiceSettlementId?: string,
  vatid?: string,
  isAgency?: boolean,
  vatInvoiceLegalEntityName?: string,
  vatInvoiceStreet?: string,
  vatInvoiceHouseNumber: string,
  vatInvoicePlace?: string,
  vatInvoiceZipCode?: string,
  isPublicProcurement: boolean,
  autoRenewal: boolean,
  eligibleForAutoRenewal: boolean,
  isIdentityNumberRequired: boolean,
  phoneVerificationCodeTime: string,
  isTempUsername: boolean,
  workingHoursWorkingDay?: string,
  workingHoursSaturday?: string,
  workingHoursSunday?: string,
  participateInSurveys?: boolean,
  chatShadowBannedAt: string | null,
  followedStores?: FollowedStoreI[],
  dominantCategories?: DominantCategoryI[],
  // Last 10 login timestamps (ISO strings), newest first. Only populated on
  // the admin /user/admin-search/{id} response.
  loginDates?: string[],
  hasIndexPremium: boolean,
}

export interface DominantCategoryI {
  module?: string;
  category?: string;
}

export interface storeInterface {
  featured: {
    items: FeaturedStoreI[];
    totalCount: number;
    page: number;
    isLoading: boolean;
  };
  followed: {
    ids: string[];
  };
}

export interface FollowedStoreI {
  storeId: string;
  userName: string;
  avatarImage?: string;
  followedAt: string;
}

export interface FeaturedStoreI {
  userId: string;
  avatarImage?: string;
  userName: string;
  registeredAt: string;
  activeAdsCount: number;
  description?: string;
}

export interface FeaturedStoresResponseI {
  totalCount: number;
  page: number;
  itemPerPage: number;
  items: FeaturedStoreI[];
}

// AD
export interface adInterface {
  forbiddAds: any;
  discountedAds?: discountedAdsInterface;
  adDetails?: adDetailsInterface;
  myAds?: null; //  CHECK THIS
  myAdsStatistic?: any; //  CHECK THIS
  newAds?: newAdsInterface;
  populars?: popularsInterface[];
  searchText?: string;
  seller?: sellerInterface;
  similarAds?: similarAdsInterface[];
  smartlinkData?: any; //   CHECK THIS
  statistics?: statisticsInterface;
  adStatistics: AdStatisticsInterface;
  subLevel?: subLevelInterface[];
  subLevelName?: string;
  subLevelParentCount?: number;
  subLevelSearch?: any; //   CHECK THIS
  // DataSource of the current sub level page (make | subcategories)
  subLevelSource?: string;
  // lv1 nodes (with children) the current sub level page was built from
  subLevelTree?: any[];
  // search query fields per level of the current sub level page
  subLevelSearchFields?: string[];
  suggestions?: suggestionsInterface;
  isAgeVerified?: boolean;
  trackedCarouselAdIds?: string[];
}

export interface AdStatisticsInterface {
  dailyViewCount: AdStatisticDailyViewCountInterface[];
  promotions: AdStatisticPromotionInterface[];
  searchedViewCount: AdStatisticSearchedViewCountInterface[];
  phoneClicks: AdStatisticDailyCountInterface[] | null;
  favoritesCount: AdStatisticDailyCountInterface[] | null;
  messageReceivedCount: AdStatisticDailyCountInterface[] | null;
  carouselScrollCount: AdStatisticDailyCountInterface[] | null;
  dailyPromotionStatus: AdStatisticDailyPromotionStatusInterface[] | null;
  adPagePosition: number | null;
}

export interface AdStatisticDailyCountInterface {
  date: string;
  count: number;
}

export interface AdStatisticDailyPromotionStatusInterface {
  date: string;
  isPromoted: boolean;
}

export interface AdStatisticDailyViewCountInterface {
  date: string;
  count: number;
}

export interface AdStatisticSearchedViewCountInterface {
  date: string;
  count: number;
}

export interface AdStatisticPromotionInterface {
  expirationDate: string;
  startDate: string;
  totalViewCount: number;
  totalSearchedViewCount: number;
}

export interface adDetailsInterface {
  category?: string;
  creator?: creatorInterface;
  details?: detailsInterface[];
  module?: string;
  routeLinks?: routeLinksInterface[];
  specialAttributes?: specialAttributesInterface[];
  summary?: summaryInterface;
}

export interface specialAttributesInterface {
  field?: string;
  iconRelativeUrl?: string;
  title?: string;
  value?: string;
}

export interface summaryInterface {
  cityId?: string;
  code?: number;
  countryId?: string;
  countyId?: string;
  // Location names returned next to the ids
  countryName?: string | null;
  countyName?: string | null;
  cityName?: string | null;
  settlementName?: string | null;
  // For wider locationScope BE builds this as a comma-separated list of
  // the picked areas (eg. "Rijeka, Osijek" or "Cijela Hrvatska")
  locationName?: string | null;
  // V2OGLASI-2648: 1=exact, 2=whole Croatia, 3=counties, 4=cities
  locationScope?: number;
  locationAreas?: Array<{ id: string; name: string }>;
  locationAreaIds?: string[];
  settlementLatitude?: number | null;
  settlementLongitude?: number | null;
  makeName?: string | null;
  makeRoute?: string | null;
  modelName?: string | null;
  modelRoute?: string | null;
  categoryLv1Name?: string | null;
  categoryLv1Route?: string | null;
  categoryLv2Name?: string | null;
  categoryLv2Route?: string | null;
  creatorEmail?: string;
  creatorId?: string;
  externalUrl?: string; //   CHECK THIS
  id?: string;
  images?: string[];
  floorPlans?: string[];
  is18Old?: boolean;
  isFavorite?: boolean;
  postedTime?: string;
  price?: number;
  priceM2?: number;
  averagePriceM2?: number;
  lowerRangePriceM2?: number;
  higherRangePriceM2?: number;
  // Phones are no longer inlined into the ad payload. `hasPhones` is a
  // boolean flag used to decide whether to render the reveal button;
  // actual numbers come from POST /api/phone/reveal/ad/{adId}.
  hasPhones?: boolean;
  previousPrice?: number;
  priceReductionPercentage?: number;
  featuredProperty?: { fieldName?: string; label?: string; score?: number };
  settlementId?: string;
  title?: string;
  videoUrl?: string;
  viewCount?: number;
  searchedViewCount?: number;
  favoriteCount?: number;
  makeId?: string;
  modelId?: string;
  makeYear?: number;
  // Populated by BE when a published MakeModelInfo entry covers this ad's
  // (makeId, modelId) — either as its primary pair or through `variants`.
  // Points to the entry's *primary* (makeId, modelId) so the FE can build
  // the info page URL directly (variant matches would otherwise resolve to a
  // non-existent slug). Null/absent when no info page exists.
  infoPage?: SimilarModelPair | null;
}

export interface detailsInterface {
  data?: detailsDataInterface[];
  name?: string;
  type?: string;
}

export interface detailsDataInterface {
  title?: string;
  value?: string;
}

export interface routeLinksInterface {
  link?: string;
  title?: string;
}

export interface creatorInterface {
  additionalCellPhone?: string | null;
  avatar?: string | null;
  cellPhone?: string;
  cityId?: string;
  countryId?: string;
  countyId?: string;
  // Location names returned next to the ids
  countryName?: string | null;
  countyName?: string | null;
  cityName?: string | null;
  settlementName?: string | null;
  locationName?: string | null;
  description?: string | null;
  email?: string;
  id?: string;
  phoneNumber?: string;
  registrationDate?: string;
  username?: string;
  replyStatisticsMessage?: string | null;
  dominantCategories?: DominantCategoryI[];
  // Flag whether the seller has phone numbers registered. Actual numbers
  // are fetched on demand through POST /api/phone/reveal/user/{userId}.
  hasPhones?: boolean;
}

export interface suggestionsInterface {
  categories?: suggestionsCategoriesInterface[];
  hits?: number;
  module?: string;
}

export interface suggestionsCategoriesInterface {
  count?: number;
  name?: string;
}

// Enhanced Search Suggestions
export interface CategoryMatchSuggestionInterface {
  displayText: string;
  url: string;
}

export interface EnhancedTextSearchSuggestionsInterface {
  textSearchResults?: suggestionsInterface;
  categoryMatchSuggestions?: CategoryMatchSuggestionInterface[];
}

export interface newAdsInterface {
  count?: number;
  data?: similarAdsInterface[];
  nextPage?: number;
  page?: number;
}

export interface discountedAdsInterface {
  count?: number;
  data?: similarAdsInterface[];
  nextPage?: number;
  page?: number;
}

// configuration/populars
export interface popularsInterface {
  category?: string | null;
  categoryRoute?: string | null;
  count?: number;
  displayName?: string;
  iconId?: string;
  module?: string;
  moduleRoute?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

export interface statisticsInterface {
  activeAdsCount?: number;
  newActiveAdsCount?: number;
  registeredUsersCount?: number;
  tradesCount?: number;
}

export interface similarAdsInterface {
  code?: number;
  id?: string;
  images?: string[];
  isFavorite?: boolean;
  isRead?: boolean;
  link?: string;
  location?: string;
  module?: string;
  postedTime?: string;
  price?: number;
  summary?: string[];
  title?: string;
  videoUrl?: string | null;
}

export interface sellerInterface {
  modules?: string[];
  hasPhones?: boolean;
}

export interface subLevelInterface {
  checked?: boolean;
  count?: number;
  dataSource?: string;
  hasChild?: boolean;
  id?: string;
  name?: string;
  route?: string;
}

// FAVORITE
export interface favoriteInterface {
  favoriteIds?: string[];
  favorites: {
    count: number;
    data: any[];
    page: number;
  }
}

// HIDDEN ADS
export interface hiddenInterface {
  hiddenAdIds?: string[];
}

// PHONES
export interface phonesInterface {
  phones: PhoneInterface[];
  phone: PhoneInterface;
  status: any; // CHECK THIS
}

// PROMOTIONS
export interface PromotionPackageInterface {
  name: string;
  description: string;
  price: number;
  module: string;
  duration: number;
  id: string;
}


export interface promotionInterface {
  packages: PromotionPackageInterface[];
}

// CREDITS
export interface CreditPackageInterface {
  name: string;
  description: string;
  price: number;
  id: string;
  creditAmount: number;
}

export interface creditInterface {
  packages: CreditPackageInterface[];
}

export interface creditAdminInterface {
  notes: {
    count: number;
    data: CreditsLogParsed[];
    page: number;
  } | null;
}

// ADMIN NOTES
export interface adminNotesAdminInterface {
  log: {
    count: number;
    data: AdminNoteParsed[];
    page: number;
  } | null;
}

// CART
export interface cartInterface {
  cart: ShoppingCart | null;
  carts: {
    count: number;
    data: ShoppingCart[];
    page: number;
  } | null;
}

// PRICE CHANGES
export interface PriceChangeList {
  data: PriceChange[];
  count: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
}

export interface PriceChangeListParsed {
  data: PriceChangeParsed[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
}

export interface PriceChange {
  date: string;
  percentage: number;
  priceFrom: number;
  priceTo: number;
}

export interface PriceChangeParsed {
  date: string;
  percentage: string;
  priceFrom: string;
  priceTo: string;
}

// SEARCH
export interface searchInterface {
  ads?: searchAdsInterface;
  controlFields?: any; //    CHECK THIS
  controls?: searchControls[];
  criteriaModules?: any; //  CHECK THIS
  isFocus?: boolean;
  savedSearches?: any; //    CHECK THIS
  isLoadingSavedSearches?: boolean;
  isSearchLoading?: boolean;
}

export interface searchControls {
  controls?: any[];
  name?: string;
}

export interface searchAdsInterface {
  count?: number;
  data?: similarAdsInterface[];
  page?: number;
}

export interface adFormInterface {
  adData?: any; //   CHECK THIS
  controls?: any; // CHECK THIS
}



// CHAT
export const messageType = {
  Text: 0,
  Image: 1,
  PDF: 2
};

export const inboxType = {
  All: null,
  Unread: 1,
  ForMyAds: 2,
  ForOtherAds: 3
};

export const groupType = {
  Single: 'single',
  ImageGroup: 'imageGroup'
};


export interface Message {
  messageId: string;
  senderId: string;
  type: number;
  content: string | React.ReactNode;
  sentAt: string;
  fileName?: string;
}

export interface Chat {
  chatId?: string | null;
  senderId: string;
  senderName: string;
  senderAvatar?: string;
  recipientId: string;
  recipientName: string;
  recipientAvatar?: string;
  adId: string;
  adCode: string;
  adTitle: string;
  adPrice?: number;
  adPreviousPrice?: number | null;
  adThumbnailUrl?: string;
  adUrl: string;
  adStatus: number;
  adViewCount: number;
  adFavoriteCount: number;
  countryId?: string;
  countyId?: string;
  cityId?: string;
  countryName?: string | null;
  countyName?: string | null;
  cityName?: string | null;
  settlementName?: string | null;
  locationName?: string | null;
  // V2OGLASI-2648: scope != 1 means AdInfo should render locationName
  // instead of the constructAddress(city/county) fallback
  locationScope?: number;
  settlementId?: string;
  adCreatedAt: string;
  messagesCount: number;
  senderLastReadMessageId?: string;
  recipientLastReadMessageId?: string;
  isSenderBlocked: boolean;
  isRecipientBlocked: boolean;
  messages: Message[];
  isUserBlockedByAdmin: boolean;
  canSendContactInfo: boolean;
  canSendUserAddress: boolean;
  senderContactInfo: {
    email: string;
    phoneNumber: string;
    messageId: string | null;
  };
  replyStatisticsMessage?: string | null;
}


export interface sendMessageRequest {
  chatId?: string | null;
  adId?: string | null;
  content: string;
  type: number;
  fileName?: string;
  email?: string;
  phoneNumber?: string;
}

export interface getChatRequest {
  chatId?: string;
  lastMessageId?: string;
  adId?: string;
}

export interface getChatsRequest {
  username?: string;
  adTitle?: string;
  inboxType?: number;
  page?: number;
  itemPerPage?: number;
  userId?: string;
  adId?: string;
}

export interface getChatsListResponse {
  chats: Chat[];
  totalCount: number;
  page: number;
  itemPerPage: number;
  totalPages: number;
}

export interface unreadCountResponse {
  count: number;
}

export interface FilterInfo {
  users: Record<string, string>[];
  adTitles: Record<string, string>[]
}

export interface chatInterface {
  chat: Chat | null;
  chats: Chat[] | [];
  unreadCount: number;
  filterInfo: FilterInfo;
  pagination: {
    currentPage: number;
    count: number;
  };
}

// MAKE MODEL INFO
export interface SimilarModelRef {
  makeId: string;
  modelId: string;
  makeName?: string;
  modelName?: string;
  adCount?: number;
}

export interface SimilarModelPair {
  makeId: string;
  modelId: string;
}

export interface EngineSpec {
  name: string;
  fuel: string;
  power: string;
  comment: string;
}

export interface SpecItem {
  label: string;
  value: string;
}

export interface SafetyInfo {
  text: string;
  euroNcapUrl?: string;
}

export interface MakeModelInfoDto {
  id: string;
  makeId: string;
  makeName: string;
  modelId: string;
  modelName: string;
  makeYearFrom: number;
  makeYearTo: number;
  imageName: string;
  // Optional page title override. When empty the FE renders the auto-generated
  // `{makeName} {modelName} ({yearFrom}–{yearTo})` line.
  title?: string;
  // Section-per-prop layout (all optional — missing section = hidden).
  overview?: string;
  advantages?: string[];
  drawbacks?: string[];
  targetBuyer?: string;
  engines?: EngineSpec[];
  specifications?: SpecItem[];
  buyingTips?: string;
  safety?: SafetyInfo;
  similarModels: SimilarModelRef[];
  // Extra (make, model) pairs covered by this info page — e.g. Golf VII +
  // Golf VII Variant. The primary makeId/modelId above still drives SEO and
  // the page URL; variants extend the ad-side match (CTA + available ads).
  variants?: SimilarModelPair[];
}

export interface MakeModelInfoListItem {
  id: string;
  makeName: string;
  modelName: string;
  makeYearFrom: number;
  makeYearTo: number;
  status: number;
}

export interface MakeModelInfoSavePayload {
  id?: string;
  makeId: string;
  modelId: string;
  makeYearFrom: number;
  makeYearTo: number;
  imageName: string;
  title?: string;
  overview?: string;
  advantages?: string[];
  drawbacks?: string[];
  targetBuyer?: string;
  engines?: EngineSpec[];
  specifications?: SpecItem[];
  buyingTips?: string;
  safety?: SafetyInfo;
  similarModels: SimilarModelPair[];
  variants: SimilarModelPair[];
}




// WEBPACK FOOTER //
// ./src/typings/interfaces.ts